import { useState, useCallback } from "react";
import { DATE_FILTERS } from "api/hooks/shared/paginatedList";

export default function useListDateFilter({ dateFilter, setDateFilter, applyCustomRange, customRange }) {
  const [customPickerOpen, setCustomPickerOpen] = useState(false);

  const displayDateFilter = customPickerOpen ? DATE_FILTERS.custom : dateFilter;

  const handleFilterChange = useCallback((filter) => {
    if (filter === DATE_FILTERS.custom) {
      setCustomPickerOpen(true);
    } else {
      setCustomPickerOpen(false);
      setDateFilter(filter);
    }
  }, [setDateFilter]);

  const handleCustomApply = useCallback(() => {
    setCustomPickerOpen(false);
    applyCustomRange(customRange);
  }, [applyCustomRange, customRange]);

  return {
    displayDateFilter,
    handleFilterChange,
    handleCustomApply,
  };
}
